import { render, staticRenderFns } from "./DrawCanvas.vue?vue&type=template&id=41ec8baf&scoped=true"
import script from "./DrawCanvas.vue?vue&type=script&lang=js"
export * from "./DrawCanvas.vue?vue&type=script&lang=js"
import style0 from "./DrawCanvas.vue?vue&type=style&index=0&id=41ec8baf&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ec8baf",
  null
  
)

export default component.exports